<template>
    <div>
        <NavBar />
        <div class="container mx-auto">
            <header>
                <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                    <h1 class="text-3xl font-bold leading-tight text-gray-900">
                        Message Type
                    </h1>
                </div>
            </header>
        </div>

        <main class="container mx-auto">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="px-4 py-6 sm:px-0">

                    <div class="flex flex-wrap">
                        <div class="w-full md:w-2/3 cursor-pointer">
                            <div class="flex flex-wrap items-center">
                                <div
                                    class="w-full md:w-1/3 text-center px-2"
                                    @click="changeMessageType({ type: 'audio', subtype: 'voice'})"
                                >
                                    <div class="rounded overflow-hidden hover:shadow py-2 bg-white">
                                        <svg class="mx-auto h-10 w-10 mt-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M21 3l-6 6m0 0V4m0 5h5M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"
                                            />
                                        </svg>

                                        <div class="px-6 py-4 text-center">
                                            <div class="font-bold text-xl mb-2">Phonemail</div>
                                            <p class="text-gray-700 text-sm">
                                                Send an audio message as phonecall
                                            </p>
                                        </div>
                                    </div>

                                </div>

                                <div
                                    class="w-full md:w-1/3 text-center px-2"
                                    @click="changeMessageType({ type: 'audio', subtype: 'voicemail'})"
                                >
                                    <div class="rounded overflow-hidden hover:shadow py-2 bg-white">
                                        <svg class="mx-auto h-10 w-10 mt-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M8 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2m-4-1v8m0 0l3-3m-3 3L9 8m-5 5h2.586a1 1 0 01.707.293l2.414 2.414a1 1 0 00.707.293h3.172a1 1 0 00.707-.293l2.414-2.414a1 1 0 01.707-.293H20"
                                            />
                                        </svg>

                                        <div class="px-6 py-4 text-center">
                                            <div class="font-bold text-xl mb-2">Voicemail</div>
                                            <p class="text-gray-700 text-sm">
                                                Send an audio message to voicemail
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="w-full md:w-1/3 text-center px-2"
                                    @click="changeMessageType({ type: 'sms', subtype: 'text'})"
                                >
                                    <div class="rounded overflow-hidden hover:shadow py-2 bg-white">
                                        <svg class="mx-auto h-10 w-10 mt-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                                        </svg>

                                        <div class="px-6 py-4 text-center">
                                            <div class="font-bold text-xl mb-2">SMS</div>
                                            <p class="text-gray-700 text-sm">
                                                Send a text message to SMS mailbox
                                            </p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="w-full md:w-1/3">
                            <Summary :summary="summary" />

                            <button
                                class="bg-green-500 hover:bg-green-700 text-white font-bold text-sm py-2 px-4 rounded my-4"
                                @click="save"
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import Summary from "../components/Summary";
import { mapGetters } from "vuex";
import NavBar from '../components/NavBar';

export default {
    name: "CampaignType",
    components: {
        Summary,
        NavBar,
    },
    data() {
        return {
            summary: {
                "message_type": "",
            }
        }
    },
    methods: {
        changeMessageType(data) {
            const payload = {
                prop: "messageType",
                val: data.type,
            };

            this.$store.commit("change", payload);

            if (data.type === 'audio') {
                const payload = {
                    prop: "audioType",
                    val: data.subtype,
                };
                this.$store.commit("change", payload);
            }
            this.summary.message_type = this.messageTypeFormatted;
        },
        save() {
            this.$router.push(this.nextRoute);
        }
    },
    computed: {
        nextRoute() {
            return `${this.$route.meta.link}`
        },
        ...mapGetters([
            "audioType",
            "messageType",
            "messageTypeFormatted",
        ]),
    },
    mounted() {
        this.summary.message_type = this.messageTypeFormatted;
    }
}
</script>
